import { useState } from "react";
import { useAdminAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from '../../assets/images/logo.png'
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
      toast.success("Welcome, Admin");
      navigate("/admin");
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!resetEmail) {
      toast.info("Please enter your email");
      return;
    }

    try {
      setResetLoading(true);
      await sendPasswordResetEmail(auth, resetEmail);
      toast.success("Password reset link sent! Check your inbox.");
      setIsModalOpen(false); // Close popup on success
      setResetEmail("");
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setResetLoading(false);
    }
  };

  return (
    // <div className="h-screen flex items-center justify-center bg-gray-100">
    <div className="h-[100dvh] bg-gray-100 flex justify-center items-center p-2">

      {/* Big Main Card */}
      <div className="w-full max-w-3xl bg-[#fffcf9] border border-black rounded-2xl shadow-lg p-3 flex flex-col h-full max-h-[95vh] overflow-hidden justify-center">
        <img src={logo} alt="Logo" className="h-16 w-auto object-contain cursor-pointe mb-4" />
        <form onSubmit={handleLogin}>
          <h2 className="text-xl font-bold mb-4 text-center">Admin Login</h2>
          <input
            type="email"
            placeholder="Email"
            className="flex-1 w-full border rounded-full px-3 py-2"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
             className="flex-1 w-full border rounded-full px-3 py-2 mt-2"
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="text-right mt-2 px-2">
            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              disabled={resetLoading}
              className="text-[12px] font-bold text-[#fa3815] hover:text-[#d62e12] transition-colors disabled:opacity-50 underline"
            >
              {resetLoading ? "Sending..." : "Forgot Password?"}
            </button>
          </div>
          <button className="w-full bg-[#fa3815] text-white py-2 rounded-full mt-2 hover:bg-[#d62e12] transition-all">Login</button>
        </form>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
          <div className="bg-white w-full max-w-md rounded-2xl p-6 shadow-2xl border border-gray-200 animate-in fade-in zoom-in duration-200">
            <h3 className="text-xl font-bold text-gray-800 mb-2">Reset Password</h3>
            <p className="text-gray-500 text-sm mb-4">
              Enter your admin email and we'll send you a link to reset your password.
            </p>
            
            <form onSubmit={handleForgotPassword}>
              <input
                type="email"
                placeholder="Admin Email Address"
                className="w-full border rounded-full px-3 py-2 mb-4"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
              />
              
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-full font-bold text-gray-600 hover:bg-gray-50 transition-all"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={resetLoading}
                  className="flex-1 px-4 py-2 bg-[#fa3815] text-white rounded-full font-bold shadow-md disabled:opacity-50 hover:bg-[#d62e12] transition-all"
                >
                  {resetLoading ? "Sending..." : "Send Link"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default Login;